import { Link, useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";

import Pagination from "../Bar/Pagination";
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as XLSX from "xlsx";
import moment from 'moment';
import { exportToExcel } from "../Helper/exportToExcel";

const UserTestResultView = () => {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState({
    page: 1,
    data: null,
    users: [],
    total: 0,
    limit: 100,
    s: "",
    user: {},
    approve: null,
  });

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      // We need to set the id in state because getOneUsersTestResult uses state.users.id
      // But better is to pass it directly.
      // Let's refactor getOneUsersTestResult to take ID.
      getOneUsersTestResult(id);
    }
  }, [searchParams]);

  const getOneUsersTestResult = async (id, extra_query = "") => {
    try {
      let query = `id=${id || state.user.id}`
      // Assuming original code meant to combine queries but didn't actually use extra_query in the final query string construction??
      // Original: let query = `id=${this.state.users.id}`
      // And ignored extra_query.

      let results = await API.getOneUserTestResult(query);
      let data = results.data;

      // console.log(data.user)

      setState(prev => ({ ...prev, users: data, user: data.user }));

    } catch (error) {
      console.log(error)
    }
  }

  const exportUsersToExcel = (data, filename) => {
    exportToExcel(data, filename);
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellText: false, cellDates: true });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const filteredData = jsonData.slice(1);

      let file_data = [];

      filteredData.forEach((data, index) => {
        const date = new Date(data[3]);
        const formattedDate = moment(date).format("YYYY-MM-DD")

        if (data && data.length !== 0) {
          file_data.push({
            first_name: data[0],
            last_name: data[1],
            custom_id: data[2],
            dob: formattedDate,
          })
        }
      });

      try {
        let results = await API.postUser(file_data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        getOneUsersTestResult(state.user.id);

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const onSearch = async (event) => {
    event.preventDefault();
    const s = event.target.value;
    setState(prev => ({ ...prev, s, page: 1 }));
    getOneUsersTestResult(state.user.id);
  }

  const onPaginationPress = (page) => {
    setState(prev => ({ ...prev, page }));
    getOneUsersTestResult(state.user.id);
  }

  const convertToText = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  const truncateString = (str, maxLength) => {
    if (!str) return "";

    let text = str;

    try {
      const obj = JSON.parse(str);
      if (obj.question_topic) {
        text = obj.question_topic;
      }
    } catch (e) {
      // Not JSON → do nothing
    }

    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    if (element) element.click();
  }

  let sort_by = {
    all_users: { name: "All users" },
    approve: { name: "Approve" },
    not_approve: { name: "Not Approve" },
    block: { name: "Block" }
  }

  let displaySort = "All users";

  if (state.approve === 0) {
    displaySort = sort_by.not_approve.name;
  } else if (state.approve === 1) {
    displaySort = sort_by.approve.name;
  } else if (state.approve === -2) {
    displaySort = sort_by.block.name;
  }

  return (
    <div className="col-12 ">
      <ToastContainer />
      <h2 className="card-title"><strong>Result Detail <b className="text-success fw-500 w-80px"> </b></strong></h2>

      <div className="card card-body card-hover-shadow p-40">
        <h2 className="card-title"><strong>User Information<b className="text-success fw-500 w-80px"> </b></strong></h2>

        <div className="card-body">
          <img
            width={100}
            height={100}
            src={state.user.profile_url}
            alt="Profile"
          />
          <div>{state.user.last_name} {state.user.first_name}</div>
        </div>
      </div>

      <div className="card card-body card-hover-shadow p-40">
        <h2 className="card-title"><strong>Blind Test <b className="text-success fw-500 w-80px"> </b></strong></h2>

        <div className="card-body">
          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-200px"><h6>Question Name</h6></th>
                <th className="text-center w-40px"><h6>Question Topic</h6></th>
                <th className="text-center w-180px"><h6>Code</h6></th>
                <th className="text-center w-200px"><h6>Level</h6></th>
                <th className="text-center w-200px"><h6>Answer</h6></th>
                <th className="text-center w-200px"><h6>Correct Answer</h6></th>
                {/* <th className="text-center w-200px"><h6>Action</h6></th> */}
              </tr>
            </thead>
            <tbody>

              {
                state.users?.blind_test_result?.map((question, index) => {

                  return <tr style={{ backgroundColor: question.answer !== question.correct_answer ? "red" : "transparent" }} key={index}>
                    <td>{index + 1}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.name, 60)}</td>
                    <td className="w-180px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.topic, 60)}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.code}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.level}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.answer}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.correct_answer}</td>
                    <td className="text-center table-actions" onClick={() => linkToNewPage(question.quiz.id)}>
                      <span>&nbsp;</span><Link className="" title="View" to={`/questionedit?id=${question.quiz.id}`}><i id={`clickview${question.quiz.id}`} ></i></Link>
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
        </div>
      </div>

      {/* Listening */}

      <div className="card card-body card-hover-shadow p-40">
        <h2 className="card-title"><strong>Listening<b className="text-success fw-500 w-80px"> </b></strong></h2>
        <div className="card-body">
          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-200px"><h6>Question Name</h6></th>
                <th className="text-center w-40px"><h6>Question Topic</h6></th>
                <th className="text-center w-180px"><h6>Code</h6></th>
                <th className="text-center w-200px"><h6>Level</h6></th>
                <th className="text-center w-200px"><h6>Answer</h6></th>
                <th className="text-center w-200px"><h6>Correct Answer</h6></th>
              </tr>
            </thead>
            <tbody>

              {
                state.users?.listening_result?.map((question, index) => {

                  return <tr style={{ backgroundColor: question.answer !== question.correct_answer ? "red" : "transparent" }} key={index}>
                    <td>{index + 1}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.name, 60)}</td>
                    <td className="w-180px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.topic.question_topic, 60)}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.code}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.level}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.answer}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.correct_answer}</td>
                    <td className="text-center table-actions" onClick={() => linkToNewPage(question.quiz.id)}>
                      <span>&nbsp;</span><Link className="" title="View" to={`/questionedit?id=${question.quiz.id}`}><i id={`clickview${question.quiz.id}`} ></i></Link>
                    </td>

                  </tr>
                })
              }
            </tbody>
          </table>

        </div>
      </div>

      {/* reading */}

      <div className="card card-body card-hover-shadow p-40">
        <h2 className="card-title"><strong>Reading<b className="text-success fw-500 w-80px"> </b></strong></h2>
        <div className="card-body">
          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-200px"><h6>Question Name</h6></th>
                <th className="text-center w-40px"><h6>Question Topic</h6></th>
                <th className="text-center w-180px"><h6>Code</h6></th>
                <th className="text-center w-200px"><h6>Level</h6></th>
                <th className="text-center w-200px"><h6>Answer</h6></th>
                <th className="text-center w-200px"><h6>Correct Answer</h6></th>
              </tr>
            </thead>
            <tbody>
              {
                state.users?.reading_result?.map((question, index) => {
                  return <tr style={{ backgroundColor: question.answer !== question.correct_answer ? "red" : "transparent" }} key={index}>
                    <td>{index + 1}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.name, 60)}</td>
                    <td className="w-180px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{truncateString(question.quiz.topic.question_topic, 60)}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.code}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.quiz.level}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.answer}</td>
                    <td className="w-100px text-center" onClick={() => linkToNewPage(question.quiz.id)}>{question.correct_answer}</td>
                    <td className="text-center table-actions" onClick={() => linkToNewPage(question.quiz.id)}>
                      <span>&nbsp;</span><Link className="" title="View" to={`/questionedit?id=${question.quiz.id}`}><i id={`clickview${question.quiz.id}`} ></i></Link>
                    </td>

                  </tr>
                })
              }
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}

export default UserTestResultView;
